function formatDate(DOU) {
    const [weekDay, month, date, year] = new Date(DOU).toDateString().split(' ');
    const dateOfUpload = date + ' ' + month + ' ' + year;

    return dateOfUpload;
}

export default formatDate;